import { render } from "./ContentTable.vue?vue&type=template&id=c89c2386&scoped=true"
import script from "./ContentTable.vue?vue&type=script&lang=js"
export * from "./ContentTable.vue?vue&type=script&lang=js"

import "./ContentTable.vue?vue&type=style&index=0&id=c89c2386&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89c2386"]])

export default __exports__